import React, { useMemo, useRef, useState } from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import axios from "axios";
import Card from "../../../../../components/Card/Card";
import CardBody from "../../../../../components/Card/CardBody";
import SaveButton from "../../../../../components/CustomInput/SaveButton";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import Button from "../../../../../components/CustomButtons/Button";
import { CircularProgress } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import PosSyncsIndex from "./PosSyncsIndex";
import AuthenticationWrapper from "../../../../../auth/AuthenticationWrapper";

function PosSync() {
  const [oauthbusy, setOauthbusy] = useState(false);
  const pollUrl = useRef(null);

  const { vestigingId } = useFormContext();

  const syncStartValue = useWatch({ name: "volatile_salesarea_data__syncStart" });
  const [running, setRunning] = useState(syncStartValue > 0);
  const apiProviderValue = useWatch({ name: "apiProvider" });
  const channelId = useWatch({ name: "custom_data.boomi.channel_id" });
  const shopId = useWatch({ name: "custom_data.boomi.shop_id" });

  const apiActions = useMemo(() => {
    let boomi = [];
    if (channelId && shopId) {
      boomi = [
        {
          label: (
            <TranslationWrapper
              tDefault={"Sync article info (Changes only)"}
              tKey={"vestigingen.form.service.label.articleinfo.changes"}
            />
          ),
          color: "info",
          url: "/import/boomi/menu-changes",
          params: {
            vid: vestigingId,
          },
        },

        {
          label: (
            <TranslationWrapper
              tDefault={"Sync stock values and prices (Changes only)"}
              tKey={"vestigingen.form.service.label.loadStocksAndPrices"}
            />
          ),
          color: "info",
          url: "/import/boomi/stock-changes?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load campaigns"} tKey={"vestigingen.form.service.label.loadCampaigns"} />
          ),
          color: "info",
          url: "/import/boomi/campaigns-all?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load product and campaign images"}
              tKey={"vestigingen.form.service.label.loadProductAndCampaignImages"}
            />
          ),
          color: "info",
          url: "/import/boomi/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load currency rates"}
              tKey={"vestigingen.form.service.label.loadCurrencyRates"}
            />
          ),
          color: "info",
          url: "/import/boomi/currency_rates?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Reset Articleinfo data (First, manual reset must be done by kappe/boomi)"}
              tKey={"vestigingen.form.service.label.articleinfo.all"}
            />
          ),
          color: "danger",
          url: "/import/boomi/menu-all",
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Reset Price & Stock data (First, manual reset must be done by kappe/boomi)"}
              tKey={"vestigingen.form.service.label.stock.all"}
            />
          ),
          color: "danger",
          url: "/import/boomi/stock-all",
          params: {
            vid: vestigingId,
          },
        },

        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ];
    } else {
      boomi = [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/boomi/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Sync stock values and prices"}
              tKey={"vestigingen.form.service.label.loadStocksAndPrices"}
            />
          ),
          color: "info",
          url: "/import/boomi/stock?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load campaigns"} tKey={"vestigingen.form.service.label.loadCampaigns"} />
          ),
          color: "info",
          url: "/import/boomi/campaigns?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load product and campaign images"}
              tKey={"vestigingen.form.service.label.loadProductAndCampaignImages"}
            />
          ),
          color: "info",
          url: "/import/boomi/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load currency rates"}
              tKey={"vestigingen.form.service.label.loadCurrencyRates"}
            />
          ),
          color: "info",
          url: "/import/boomi/currency_rates?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ];
    }
    return {
      BOOMI: boomi,
      TAURUS: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/taurus/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Get Settings"} tKey={"vestigingen.form.service.label.getSettings"} />,
          color: "info",
          url: "/import/taurus/getSettings?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Get Terminals"} tKey={"vestigingen.form.service.label.getTerminals"} />,
          color: "info",
          url: "/import/taurus/getTerminals?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/taurus/tables/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
      ],
      TWEAKWISE: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/tweakwise/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load product images"} tKey={"vestigingen.form.service.label.loadImages"} />
          ),
          color: "info",
          url: "/import/tweakwise/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
      ],

      LIGHTSPEED: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/lightspeed/menu?&debug=true&gtd=true&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      LIGHTSPEEDK: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/lightspeedk/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      NCRALOHA: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/aloha/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      UNTILL: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/untill/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      NUVOPOS: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/nuvopos/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
    };
  }, [vestigingId, channelId]);

  const oauthAction = useMemo(
    () => ({
      LIGHTSPEED: [
        {
          label: "Login OAuth",
          color: "danger",
          type: "lightspeed",
        },
      ],
      LIGHTSPEEDK: [
        {
          label: "Login OAuth",
          color: "danger",
          type: "lightspeedk",
        },
      ],
    }),
    []
  );

  const initAction = (action) => {
    if (!running || action?.type === "resetSyncState") {
      const http = axios.create({
        baseURL: "/",
      });

      let url = action.url;

      // Format action for post
      url = url.split("?")[0];
      url = url.endsWith("/") ? url.slice(0, -1) : url;

      if (action?.type === "resetSyncState") {
        http
          .post(url, action.params)
          .then((response) => {
            if (response.data.data.success) {
              toast.success(response.data.data.message);
            } else {
              toast.error(response.data.data.message);
            }
          })
          .catch(() => {
            toast.error(<TranslationWrapper tKey={"Something went wrong!"} />);
          });

        return;
      }

      if (!running) {
        setRunning(true);

        http
          .get(url, { params: action.params })
          .then((response) => {
            const cacheKey = response.data;
            // if (typeof cacheKey !== "string" || !cacheKey.startsWith("pos-import")) {
            //   toast.error(
            //     <TranslationWrapper tKey={"Error. POS Action failed."} tDefault={"Error. POS Action failed."} />
            //   );
            //   setIframeUrl("data:text/html;charset=utf-8," + escape(response.data));
            //   setIndex((prevValue) => prevValue + 1);
            //   setRunning(false);
            //   return;
            // }

            pollUrl.current = "/import/" + cacheKey;
            setRunning(false); // instead of polling
            // poll({
            //   fn: pollPosCacheRequest,
            //   validate: pollPosCacheValidate,
            //   interval: 10000,
            //   maxAttempts: 270,
            // })
            //   .then(() => {
            //     setIframeUrl(pollUrl.current);
            //     setIndex((prevValue) => prevValue + 1);
            //     setRunning(false);
            //   })
            //   .catch((err) => console.log(err));
          })
          .catch((err) => {
            console.log(err);
            toast.error(
              <TranslationWrapper tDefault={"Error. POS Action failed."} tKey={"Error. POS Action failed."} />
            );
            setRunning(false);
          });
      }
    }
  };

  const redirectOAuth = (type) => {
    setOauthbusy(true);

    const url = "core/oauth/get_authorize_uri?api=" + type + "&vid=" + vestigingId;

    axios
      .get(url)
      .then((response) => {
        window.location = response.data.data.redirectUri;
      })
      .finally(() => {
        setOauthbusy(false);
      });
  };

  const renderButtons = () => {
    let apiButtons = [];
    let oauthButtons = [];

    let api = apiProviderValue;

    if (apiActions[api] !== undefined) {
      apiButtons = apiActions[api].map((action, key) => {
        let button = null;

        /**
         * Als er een extra check is dan moet die ook true zijn
         */
        if (action.extraCheck !== undefined && action.extraCheck()) {
          if (action.wrap) {
            button = action.wrap(
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          } else {
            button = (
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          }
        }

        /**
         * Als er geen extra Check is dan altijd toevoegen
         */
        if (action.extraCheck === undefined) {
          if (action.wrap) {
            button = action.wrap(
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          } else {
            button = (
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          }
        }

        if (action.permissionKey !== undefined) {
          button = <AuthenticationWrapper permissionKey={action.permissionKey}>{button}</AuthenticationWrapper>;
        }

        return button;
      });
    }

    if (oauthAction[api] !== undefined) {
      oauthButtons = oauthAction[api].map((action, key) => {
        let button = (
          <SaveButton
            buttonText={action.label}
            color={action.color}
            key={"oauth_" + key}
            onClick={() => redirectOAuth(action.type)}
            saving={oauthbusy}
          />
        );

        return button;
      });
    }

    // buttons = actions.map((action, key) => {
    //   return (
    //     <Button key={"action_" + key} color={action.color} onClick={() => initAction(action)}>
    //       {action.label}
    //     </Button>
    //   );
    // });

    return [...apiButtons, ...oauthButtons];
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridContainer>
            <GridItem>
              {running ? (
                <CircularProgress
                  style={{
                    width: "30px",
                    height: "30px",
                    position: "relative",
                    top: "10px",
                    marginRight: "10px",
                  }}
                />
              ) : null}
              {renderButtons()}
            </GridItem>
          </GridContainer>
          <PosSyncsIndex />
        </CardBody>
      </Card>
    </div>
  );
}

export default PosSync;
